module.exports = __webpack_public_path__ + "static/side-img-7-f8f0384ec2277df98fd282136b007135.png";